<template>
	<template v-if="!repair">
		<!-- 不排号 -->
		<div class="wrap-noNumber" v-if="sceneSortStatus==0">
			<div class="top">
				<div class="top-left">
					<div>长江索道景区运营实时信息</div>
					<div>Chongqing Changjiang Cableway Real-time Operational Information</div>
				</div>
				<div class="top-right">
					<div>{{dateTime}}</div>
					<div>景区日最大承载量: {{maxNumber}}</div>
				</div>
			</div>
			<div class="middle">
				<div class="middle-top" v-if="selfTimeList.length>0">
					<div class="middle-top-area">
						<div style="display: inline-block;">
							<div>
								[本站] {{config.companyName}}
								<span class="yellow">{{self.projectName}} </span>
								({{selfAdd||self.projectRemark}})
							</div>
							<div style="font-size: 0.28rem;">
								[This Station] Changjiang Cableway
								<span v-if="selfTimeList[0].projectExtend.display.projectNameEn">
									-{{selfTimeList[0].projectExtend.display.projectNameEn}}
								</span>
							</div>
						</div>
					</div>
					<div class="middle-top-time">
						<div>
							<div>
								候乘区时段
								<span class="yellow">{{selfTimeList[0].batchDateFrom.substr(10,6)}}-{{selfTimeList[0].batchDateTo.substr(10,6)}}</span>
							</div>
							<div style="font-size: 0.28rem;">
								boarding area time slot
								<span>{{selfTimeList[0].batchDateFrom.substr(10,6)}}-{{selfTimeList[0].batchDateTo.substr(10,6)}}</span>
							</div>
						</div>
						<div style="margin-left:0.36rem;" v-if="self.sortDisplay&&self.sortDisplay.display">
							<div>
								乘坐序号
								<span class="yellow">{{self.sortDisplay.display}}</span>
							</div>
							<div style="font-size: 0.28rem;">
								Purchase Order No.
								{{self.sortDisplay.display}}
							</div>
						</div>
					</div>
					<div class="middle-top-num">
						<div>
							<div><span>本时段余票 <span class="number">{{selfTimeList[0].batchDisplayHasNum}}</span> 张</span></div>
							<div style="font-size: 0.28rem;text-align: center;">
								Current slot remaining 
								<span style="margin: 0 0.08rem;">{{selfTimeList[0].batchDisplayHasNum}}</span>
								<span v-if="selfTimeList[0].batchDisplayHasNum>1">tickets</span>
								<span v-else>ticket</span>
							</div>
						</div>
						<div>
							<div><span v-if="selfTimeList.length>1">下一时段余票 <span class="number">{{selfTimeList[1].batchDisplayHasNum}}</span> 张</span></div>
							<div style="font-size: 0.28rem;text-align: center;" v-if="selfTimeList.length>1">
								Next slot remaining 
								<span style="margin: 0 0.08rem;">{{selfTimeList[1].batchDisplayHasNum}}</span>
								<span v-if="selfTimeList[1].batchDisplayHasNum>1">tickets</span>
								<span v-else>ticket</span>
							</div>
						</div>
						<div>
							<div><span>今日余票 <span class="number">{{selfTotal}}</span> 张</span></div>
							<div style="font-size: 0.28rem;text-align: center;">
								Today's remaining 
								<span style="margin: 0 0.08rem;">{{selfTotal}}</span>
								<span v-if="selfTotal>1">tickets</span>
								<span v-else>ticket</span>
							</div>
						</div>
					</div>
				</div>
				<div class="middle-bottom" v-if="otherTimeList.length>0">
					<span>
						[对岸]{{config.companyName}}
						<span class="yellow">{{other.projectName}}</span>
						({{otherAdd||other.projectRemark}})
					</span>
					<span>本时段余票 <span class="number">{{otherTimeList[0].batchDisplayHasNum}}</span> 张</span>
					<span v-if="otherTimeList.length>1">下一时段余票 <span class="number">{{otherTimeList[1].batchDisplayHasNum}}</span> 张</span>
					<span>今日余票 <span class="number">{{otherTotal}}</span> 张</span>
				</div>
			</div>
			
			<div class="bottom">
				<!-- <span>温馨提示:</span> -->
				<marquee scrollamount="7" style="height: 0.6rem;font-size: 0.4rem;" v-html="screenTip" v-if="rollingSubtitles==1">
					
				</marquee>
				<div style="height: 0.6rem;font-size: 0.4rem;text-align: center;width: 100%;" v-html="screenTip" v-else>
					
				</div>
			</div>
			<!--扫码购票-->
			<div class="scan-code" v-if="config2.showScanningCode=='1'">
				<div class="scan-img">
					<div>
						<img src="../assets/image/scanCode.png"/>
					</div>
					<div style="margin-top: 0.6rem;font-size: 0.4rem;">
						扫码购票
					</div>
				</div>
				
				<div class="scan-introduce">
					<div style="color: #ff0000;font-size: 0.48rem;font-weight: bold;">
						购票说明：
					</div>
					<div class="scan-phone">
						<div>
							1.扫描上方二维码，实名预约购票；
						</div>
						<div>
							2.景区咨询电话：023-68816888。
						</div>
					</div>
				</div>
			</div>
			
		</div>
		<!-- 排号 -->
		<div class="wrap-number" v-if="sceneSortStatus==1">
			<!-- 本站 -->
			<div class="top">
				<div class="top1">
					<div class="top1-left">
						<div>
							<span>当前时间</span>
							<span class="left-number">{{hourTime}}</span>
						</div>
						<div>
							<span>最大载客量</span>
							<span class="left-number">{{maxNumber}}</span>
						</div>
					</div>
					<div class="top1-right">
						<span>
							【本站】{{config.companyName}}
						</span>
						<span>
							{{self.projectName}}
						</span>
						<span style="margin-left: 0.1rem;">
							{{selfAdd||self.projectRemark}}
						</span>
					</div>
				</div>
				<div class="top2" :style="{color:self.color}">
					{{self.autoTitle}}
				</div>
				<div class="top3">
					{{self.showStart}}<span>—</span>{{self.showEnd}}
				</div>
				<div class="top4">
					<!-- 排号和时间都不显示 -->
					<template v-if="!config2.showNumberTo&&!config2.showEntryTime">
						<div style="font-size: 0.64rem;width: 100%;">
							<span>今日余票</span>
							<span style="font-size:0.92rem;">{{self.batchHasNum}}</span>
						</div>
					</template>
					<!-- 排号和时间显示一个 -->
					<template v-if="config2.showNumberTo!=config2.showEntryTime">
						<div style="width:50%;justify-content: flex-start;" v-if="config2.showNumberTo=='1'">
							<span>已排号至</span>
							<span>{{self.sortTotalCapacity}}</span>
						</div>
						<div style="width:50%;justify-content: flex-start;" v-if="config2.showEntryTime=='1'">
							<span>预计排队进入时间</span>
							<span>{{self.sortTotalTime}}</span>
						</div>
						<div style="width: 50%;justify-content: flex-end;">
							<span>今日余票</span>
							<span>{{self.batchHasNum}}</span>
						</div>
					</template>
					<!-- 排号和时间都显示 -->
					<template v-if="config2.showNumberTo=='1'&&config2.showEntryTime=='1'">
						<div style="width: 30%;padding-left: 0.2rem;display: flex;justify-content: flex-start;">
							<span>已排号至</span>
							<span>{{self.sortTotalCapacity}}</span>
						</div>
						<div style="width: 40%;">
							<span>预计排队进入时间</span>
							<span>{{self.sortTotalTime}}</span>
						</div>
						<div style="width: 30%;padding-right: 0.2rem;display: flex;justify-content: flex-end;">
							<span>今日余票</span>
							<span>{{self.batchHasNum}}</span>
						</div>
					</template>
				</div>
			</div>
			
			<div class="middle">
				<div>
					<marquee scrollamount="7" style="height: 0.6rem;font-size: 0.4rem;" v-html="screenTip">
						
					</marquee>
				</div>
				
			</div>
			<!-- 对岸 -->
			<div class="bottom">
				<div class="bottom1">
					<!-- 排号和时间只显示一个，或者都显示 -->
					<div class="bottom1-left" :style="{textAlign:config2.showNumberTo=='1'||config2.showEntryTime=='1'?'left':'center'}">
						<span>
							【对岸】{{config.companyName}}
						</span>
						<span>
							{{other.projectName}}
						</span>
						<span style="margin-left: 0.1rem;">
							{{otherAdd||other.projectRemark}}
						</span>
					</div>
					<!-- 排号和时间只显示一个，或者都显示 -->
					<div class="bottom1-right" v-if="config2.showNumberTo=='1'||config2.showEntryTime=='1'">
						<span :style="{color:other.color}">{{other.autoTitle}}</span>
						<span>{{other.showStart}}-{{other.showEnd}}</span>
					</div>
				</div>
				
				<div class="bottom2">
					<!--排号和时间都不显示 -->
					<template v-if="!config2.showNumberTo&&!config2.showEntryTime">
						<div style="width:50%;">
							<span :style="{color:other.color}">{{other.autoTitle}}</span>
							<span>{{other.showStart}}-{{other.showEnd}}</span>
						</div>
						<div style="width: 50%;">
							<span>今日余票</span>
							<span>{{other.batchHasNum}}</span>
						</div>
					</template>
					<!-- 排号和时间显示一个-->
					<template v-if="config2.showNumberTo!=config2.showEntryTime">
						<div style="width:50%;justify-content: flex-start;" v-if="config2.showNumberTo=='1'">
							<span>已排号至</span>
							<span>{{other.sortTotalCapacity}}</span>
						</div>
						<div style="width:50%;justify-content: flex-start;" v-if="config2.showEntryTime=='1'">
							<span>预计排队进入时间</span>
							<span>{{other.sortTotalTime}}</span>
						</div>
						<div style="width: 50%;justify-content: flex-end;">
							<span>今日余票</span>
							<span>{{other.batchHasNum}}</span>
						</div>
					</template>
					<!-- 排号和时间都显示 -->
					<template v-if="config2.showNumberTo=='1'&&config2.showEntryTime=='1'">
						<div style="width: 30%;padding-left: 0.2rem;display: flex;justify-content: flex-start;">
							<span>已排号至</span>
							<span>{{other.sortTotalCapacity}}</span>
						</div>
						<div style="width: 40%;">
							<span>预计排队进入时间</span>
							<span>{{other.sortTotalTime}}</span>
						</div>
						<div style="width: 30%;padding-right: 0.2rem;display: flex;justify-content: flex-end;">
							<span>今日余票</span>
							<span>{{other.batchHasNum}}</span>
						</div>
					</template>
				</div>
				
				<div class="bottom3" v-html="screenBottomTip">
				</div>
				<div class="bottom4">
					<span style="font-size: 12px;color: #cccccc;" v-if='showStatus'>设备编号:{{deviceKey}}</span>
					<span style="color: #ff0000;font-size: 16px;" v-if='showStatus'>状态：{{errMsg}}</span>
					<span style="text-align: right;flex: 1;">
						<img src="../assets/image/tbdLogo.png" style="height:18px;"/>
						{{versionName}}
					</span>
				</div>
				
			</div>
			
			<!--扫码购票-->
			<div class="scan-code" v-if="config2.showScanningCode=='10'">
				<div class="scan-img">
					<div>
						<img src="../assets/image/scanCode.png"/>
					</div>
					<div style="margin-top: 0.6rem;font-size: 0.4rem;">
						扫码购票
					</div>
				</div>
				
				<div class="scan-introduce">
					<div style="color: #ff0000;font-size: 0.48rem;font-weight: bold;">
						购票说明：
					</div>
					<div class="scan-phone">
						<div>
							1.扫描上方二维码，实名预约购票；
						</div>
						<div>
							2.景区咨询电话：023-68816888。
						</div>
					</div>
				</div>
			</div>
		</div>
	</template>
	
	
	<!-- 设备维修中 -->
	<div class="wrap-number" v-else style="text-align: center;padding-top: 4rem;font-size: 0.6rem;color: #ffffff;">
		维修中...
	</div>
</template>

<script setup>
import {ref,reactive,onUnmounted,onMounted} from 'vue'
import {useRoute} from 'vue-router'
import $request from '../assets/js/request.js'
let route = useRoute()
//响应式变量
let errMsg=ref('')
let maxNumber=ref(0)//最大购买数量
let screenTip=ref('')//配置信息
let self=ref({})//本站点信息
let other=ref({})//其他站点信息
let selfAdd=ref('')//本站地址
let otherAdd=ref('')//对面地址
let selfTimeList=ref([])//本站时段列表
let otherTimeList=ref([])//对岸时段列表
let screenBottomTip=ref('')//底部文字
let sceneSortStatus=ref('')//排号是否上下架
let deviceKey=route.query.hardKey||route.query.deviceKey||''
let dateTime=ref('')
let hourTime=ref('')
let selfTotal=ref(0)//本站总库存
let otherTotal=ref(0)//对面总库存
let repair=ref(false)
//普通变量
let showStatus=false
let config=''
let config2=''
let token=''
let versionName=localStorage.versionName
let leftIndex = 0 // 当前显示的数据起始索引
let rightIndex=0
let dataTimer=''
let timeTimer=''
let ifFirstLoad=false
let rollingSubtitles=ref('')

if(sessionStorage.config){
  token=JSON.parse(sessionStorage.config).token
  config=JSON.parse(sessionStorage.config)//登录缓存的本地信息
  config2=config.config
	rollingSubtitles.value=config2.rollingSubtitles
  if(config2.showEntryTime){
    config2.showEntryTime=parseInt(config2.showEntryTime)
  }
  if(config2.showNumberTo){
    config2.showNumberTo=parseInt(config2.showNumberTo)
  }
  if(config2.showScanningCode){
    config2.showScanningCode=parseInt(config2.showScanningCode)
  }
}
//---获取排队信息
let data={
  companyId:config.companyId,
	batchIndex:0
}
let getSort=()=>{
  $request('tbd-product/sort/scene/batchQuery?token='+token, data).then((res) => {
		try {
			repair.value=false
			if (res.code == '00') {
			  showStatus=false
			  let sortInfo=res.data||[]
				//获取南北站总体数据
				let newArr=[]
				sortInfo.forEach(item=>{
					//等于-1为南北站总的数据
					if(item.batchIndex==-1){
						newArr.push(item)
					}
				})
				//站点Id
				let projectId1=newArr[0].projectId
				let projectId2=newArr[1].projectId
				screenTip.value=res.main[projectId1].projectExtend.screenTip||''
				selfAdd.value=res.main[projectId1].projectExtend.projectAddress||''
				otherAdd.value=res.main[projectId2].projectExtend.projectAddress||''
				screenBottomTip.value=res.main[projectId1].projectExtend.screenBottomTip||''
				sceneSortStatus.value=res.main[projectId1].sceneSortStatus
				maxNumber=0
				newArr.forEach(item=>{
				  maxNumber+=item.batchDisplayNum
				  item.autoTitle = item.showEnd >= item.sortTotalCapacity ? '请进入等候区' : '正进入验号区号段'
				  item.color = item.showEnd >= item.sortTotalCapacity ? '#ff0000' : '#ffffff'
				})
				self.value=newArr[0]
				other.value=newArr[1]
				//获取南北站分时段数据
				selfTimeList.value=[]
				otherTimeList.value=[]
				selfTotal.value=0
				otherTotal.value=0
				sortInfo.forEach(item=>{
					//不等于-1为各个时段分时段数据
					if(item.batchIndex!=-1){
						if(item.projectId==projectId1){
							selfTimeList.value.push(item)
							selfTotal.value+=item.batchDisplayHasNum
						}
						if(item.projectId==projectId2){
							otherTimeList.value.push(item)
							otherTotal.value+=item.batchDisplayHasNum
						}
					}
				})
				dataTimer=setTimeout(getSort,1000)
			}else{
			  errMsg.value=res.message
			  showStatus=true
				dataTimer=setTimeout(getSort,1000)
			} 
		} catch (error) {
			//停运检修时获取不到数据，一分钟去请求一次
			dataTimer=setTimeout(getSort,1000*60)
			repair.value=true
		}
  }).catch(()=>{
    errMsg.value='请求失败'
    showStatus=true
		dataTimer=setTimeout(getSort,1000)
  })
 
}
//---时间显示
let getTime=()=>{
	dateTime.value=new Date().Format('yyyy-MM-dd hh:mm:ss')
	hourTime.value=new Date().Format('hh:mm:ss')
	timeTimer=setInterval(()=>{
		dateTime.value=new Date().Format('yyyy-MM-dd hh:mm:ss')
		hourTime.value=new Date().Format('hh:mm:ss')
	},1000)
}

onMounted(()=>{
	getTime()
	getSort()
})
onUnmounted(()=>{
	// 清除定时器，避免内存泄漏
	if (dataTimer) {
		clearTimeout(dataTimer)
	}
	if (timeTimer) {
		clearInterval(timeTimer)
	}
})
	
</script>
<style lang="scss" scoped>
	//不排号
.wrap-noNumber{
	background: url('../assets/image/sortScreen/bodyBg.png') no-repeat;
	background-size:100% 100%;
	color: #ffffff;
	padding: 0 0.3rem;
	min-height: 100%;
}
.wrap-number{
	background: url('../assets/image/sortScreen/sortBg.jpg') no-repeat;
	background-size:100% 100%;
	color: #ffffff;
	padding: 0 0.3rem;
	min-height: 100%;
}
.wrap-noNumber{
	.top{
		height: 1.8rem;
		display: flex;
		align-items: center;
	}
	.top-left{
		font-size: 0.64rem;
		font-weight: 600;
		width: 100%;
		text-align: center;
		div:last-child{
			font-size: 0.28rem;
		}
	}
	.top-right{
		position: absolute;
		top: 0.4rem;
		right: 0.4rem;
		div:first-child{
			font-size: 0.36rem;
			font-weight: 600;
		}
		div:nth-child(2){
			font-size: 0.3rem;
			color: #C0CDFF;
		}
	}
	.middle{
		background: url('/src/assets/image/sortScreen/middleBg.png') no-repeat;
		background-size: 100% 100%;
		padding:0.5rem;
	}
	.middle-top-area{
		font-size: 0.64rem;
		text-align: center;
		font-weight: 600;
	}
	.middle-top-time{
		font-size: 0.64rem;
		text-align: center;
		margin-top: 0.4rem;
		font-weight: 600;
		display: flex;
		justify-content: center;
	}
	.middle-top-num{
		display: flex;
		justify-content:space-between;
		font-size: 0.64rem;
		border-bottom:0.02rem solid;
		border-image:linear-gradient(270deg, rgba(21, 43, 154, 1), rgba(38, 119, 215, 1), rgba(21, 43, 154, 1)) 2 2;
		padding: 0.6rem 0 0.4rem 0;
		font-weight: 600;
	}
	.middle-bottom{
		display: flex;
		justify-content: space-between;
		font-size: 0.42rem;
		margin-top: 0.4rem;
		color: #D9E3FF;
		font-weight: 600;
	}
	.bottom{
		margin-top: 0.1rem;
		background: url('../assets/image/sortScreen/bottomBg.png') no-repeat;
		background-size: 100% 100%;
		height: 1.1rem;
		padding: 0.1rem 0.4rem;
		display: flex;
		align-items: center;
		span{
			font-size: 0.36rem;
			flex-shrink: 0;
		}
	}
	.yellow{
		color: #FDF604;
		font-weight: 600;
	}
	.number{
		font-weight: 600;
	}
}
//排号
.wrap-number{
	.top{
		text-align: center;
	}
	.top1{
		display: flex;
		align-items: center;
		padding-top: 0.4rem;
		font-size: 0.48rem;
	}
	.top1-left{
		flex-shrink: 0;
		text-align: left;
	}
	.left-number{
		margin-left: 0.2rem;
		font-size: 0.52rem;
	}
	.top1-right{
		flex: 1;
		text-align: left;
		padding-left: 1.6rem;
	}
	.top1-right span:first-child{
		color: #ff0000;
	}
	.top1-right span:nth-child(2){
		color:#faf801;
		font-weight: bold;
	}
	.top1-right span:last-child{
		font-size: 0.4rem;
	}
	.top2{
		font-size: 0.68rem;
	}
	.top3{
		font-size: 2.16rem;
		color: #ff0000;
		span{
			margin:0 0.6rem;
		}
	}
	.top4{
		display: flex;
		font-size: 0.44rem;
		div{
			display: flex;
			align-items: center;
			justify-content: center;
		}
		span:first-child{
			margin-right: 0.1rem;
		}
		span:last-child{
			font-size: 0.72rem;
		}
	}
	.middle{
		margin-top: 0.2rem;
		div{
			padding:0 0.2rem;
			border:3px solid #e00101;
			text-shadow: 0 0.05rem 0.5rem #8df;
			color: #ffffff;
			font-size: 0.56rem;
			display: flex;
			align-items: center;
		}
	}
	.bottom{
		margin-top: 0.3rem;
	}
	.bottom1{
		display: flex;
		align-items:center;
		justify-content: space-between;
	}
	.bottom1-left{
		font-size: 0.48rem;
		flex: 1;
	}
	.bottom1-left span:first-child{
		color: #ff0000;
	}
	.bottom1-left span:nth-child(2){
		color:#faf801;
		font-weight: bold;
	}
	.bottom1-left span:last-child{
		font-size: 0.4rem;
	}
	.bottom1-right span:first-child{
		font-size: 0.44rem;	
		margin-right: 0.1rem;
	}
	.bottom1-right span:last-child{
		font-size: 0.52rem;
	}
	.bottom2{
		display: flex;
		font-size: 0.44rem;
		margin-top: 0.35rem;
		div{
			display: flex;
			align-items: center;
			justify-content: center;
		}
		span:first-child{
			margin-right: 0.1rem;
		}
		span:last-child{
			font-size: 0.72rem;
		}
	}
	.surplus2{
		width: 30%;
	}
	.surplus2.on{
		width: 50%;
	}
	.bottom3{
		font-size:0.28rem;
		font-weight: bold;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		text-align: center;
		margin-top: 0.06rem;
	}
	.bottom4{
		padding:0 0.2rem;
		position: absolute;
		bottom:10px;
		left:0;
		width: 100%;
		display: flex;
		font-size:20px;
		align-items: center;
		span{
			width: 33.3%;
		}
	}
}

	// 扫码购票
.scan-code{
	margin-top: 2.8rem;
}
.scan-img{
	text-align: center;
	img{
		width:200px;
	}
}
.scan-introduce{
	padding: 1.2rem 0 0 1.6rem;
}
.scan-phone div{
	margin-top: 0.6rem;
	font-size: 0.4rem;
}
@media only screen and (max-height:1000px) {
	.bottom-config{
		position: initial;
		margin-top: 0.2rem;
	}
}
	
</style>